import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Heading from "../Component/Heading";
import {
  TransactionAction,
  couponDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import { apiUrl, createOrder, handleCoupon } from "../Utils/constants";
import Popup2 from "../Component/Popup2";
import GreyLine from "../Component/GreyLine";
import moment from "moment";
import NavText from "../Component/NavText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { getContentData } from "../Utils/content";

const TermsCondtionContent = ({appname}) => {
  const [couponsuccess, setCouponSuccess] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);

  const [couponcost, setCouponCost] = useState(null);
  const [couponerror, setCouponError] = useState(null);
  const [couponcode, setCouponCode] = useState(null);
  const [couponid, setCouponId] = useState(null);
  const [ogvalues, setOg] = useState(null);
  const [apiStatus, setApiStatus] = useState("");

  const [buttonClicked, setButtonClicked] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePopup2 = () => {
    setShowPopup2(!showPopup2);
  };
  const navigate = useNavigate();
  const storeSel = useSelector((state) => state);
  const DataStore = storeSel.UrlData.userDetails;
  const planNameredux = storeSel.UrlData.planName;
  const selectedCategory = storeSel.Categories.selectedCategory;
  const selectedBranch = storeSel.Categories.selectedBranch;

  const continuosData = storeSel?.emailData?.checkoboxCheck;

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setButtonClicked(true);
    setLoading(true);

    var bodyData2 = {
      planid: DataStore.planid,
      sessionid: DataStore.sessionid,
      contact: DataStore?.phone?.toString() || " ",
      basecost: DataStore.Amount,
      sumcost: DataStore["Total Amount"],
      taxcost: DataStore.Taxes,
      taxpercent: DataStore.taxpercent,
      amountpaid: " ",
      pendingamount: " ",
      // couponcost: couponcost,
      // couponcode: couponcode,
      // couponid: couponid,
      tdspercent: " ",
      tdscost: " ",
      invoiceid: " ",
      gstn: " ",
      istrial: DataStore.isTrial,
      gstname: " ",
      billto: " ",
      paymentmode: "online",
      paymentmethod: " ",
      status: "attempting",
      statusmsg: "on cost breakdown page",
      billdate: "0000-00-00",
      startdate: DataStore.startdate,
      userid: DataStore.userid,
      continous: continuosData ? continuosData : 0,
    };

    await createOrder(bodyData2, ogvalues, DataStore)
      .then((orderData) => {
        setApiStatus("success");
        dispatch(
          TransactionAction({
            orderid: orderData.id,
            transactionid: orderData.transactionid,
            transactionuid: orderData.transactionuid,
          })
        );
        navigate(
          `/${selectedCategory}/${selectedBranch}/${planNameredux}/payment`
        );
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data.message === "You cannot buy this plan right now!!"
        ) {
          togglePopup2();
        }
        setApiStatus("error");
        setButtonClicked(false);
        console.log("Axios request error:", e);
      });

    setLoading(false);
  };

  const formattedStartDate = moment(DataStore["startdate"]).format(
    "DD MMM YYYY"
  );
  const formattedEndDate = moment(DataStore["Expiry Date"]).format(
    "DD MMM YYYY"
  );

  return (
    <div className=" terms-condition-content  home-content-container start-content-container">
      <NavText
        currentPageText="Confirmation"
        name={DataStore.name}
        planname={DataStore["Plan Name"]}
      />

      <Heading headingText="Do you agree to our terms?" />

      <div className="home-scroll-content">
        <h4 className="sub-heading-home">
          {planNameredux.toUpperCase()} - {DataStore.name}
        </h4>
        <p>
          {DataStore["Total Sessions"]} session to be used at the{" "}
          {getContentData(appname).brandName} Studio.
        </p>
        <p>
          The {DataStore.daystime} day expiration period starts from the start
          date of your package.
        </p>

        <ul
          style={{ margin: "0px 20px" }}
          dangerouslySetInnerHTML={{
            __html: getContentData(appname).termsAndConditionsHTML,
          }}
        ></ul>

        <p>
          By signing this agreement you have confirmed that you have understood
          and agreed to the T&C of this package.
        </p>
      </div>

      <form className="Start-page-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-input confirmation-form">
          {!buttonClicked ? (
            <button
              type="submit"
              className="start-submit-input confirmation-button"
            >
              I Agree, Confirm My Order
            </button>
          ) : loading || apiStatus !== "success" ? (
            <Player
              autoplay
              loop
              src="asset/Img/spinner.json"
              style={{ width: "50px", height: "50px" }}
            >
              <Controls
                visible={false}
                buttons={["play", "repeat", "frame", "debug"]}
              />
            </Player>
          ) : null}
        </div>
      </form>

      {showPopup2 && (
        <Popup2
          togglePopup2={togglePopup2}
          paratext={
            DataStore.isTrial === 1
              ? "You have already enrolled once for the trial of this plan."
              : "You are already enrolled in this plan. Please note that users cannot purchase a new plan until their current or upcoming plan has expired."
          }
          title="YOU CAN'T PURCHASE THIS PLAN!"
        />
      )}
    </div>
  );
};

export default TermsCondtionContent;
